import React, { useEffect } from 'react';
import styles from './InitialAnimation.module.scss'

const InitialAnimation = ({ onAnimationComplete }) => {
  useEffect(() => {
    const animationDuration = 3000;

    const timeout = setTimeout(() => {
      onAnimationComplete();
    }, animationDuration);

    return () => {
      clearTimeout(timeout);
    };
  }, [onAnimationComplete]);

    return (
        <div className={styles.container}>
            <svg className={styles.InitialAnimation} viewBox="0 0 1280 720">
                <text className={styles.name} text-anchor="middle" x="50%" y="50%">Marcos Maio</text>
                <text className={styles.info} text-anchor="middle" x="50%" y="62%">Web Designer & Programming</text>
            </svg>
        </div>
    );
};

export default InitialAnimation;